import React, { FC, ReactNode, useEffect, useRef } from 'react';
import { useTheme, useMediaQuery } from '@material-ui/core';
import { AuthContext } from '@ryanar/react-auth-provider';
import { useHistory } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import { SideMenu } from 'ui/structure/SideMenu';
import { ForcibleLogoutModal } from 'components/modals';
import auth from 'utils/auth';
import routePaths from 'routes/routePaths';
import useIntersectionRatio from 'utils/useIntersectionRatio';
// import NoAccessModal from 'components/modals/NoAccessModal/NoAccessModal';
import SessionTimer from './SessionTimer/SessionTimer';
import HeaderMenu from './parts/HeaderMenu';

import styles from './MenuWrapper.module.css';

interface IMenuWrapper {
  children: ReactNode;
}

const MenuWrapper: FC<IMenuWrapper> = ({ children }: IMenuWrapper) => {
  const { authenticated, setAuthenticated } = React.useContext(AuthContext);
  const history = useHistory();

  const contentRef = useRef<HTMLDivElement>(null);
  // this hook triggers re-render when children content height gets changed, so the scrollbar may adapt
  useIntersectionRatio(contentRef);

  const downMdScreen = useMediaQuery(useTheme().breakpoints.down('sm'));

  const getTrackVertical = (props) => <div {...props} className={styles.trackVertical} />;
  const getThumbVertical = (props) => <div {...props} className={styles.thumbVertical} />;

  useEffect(() => {
    if (!authenticated) {
      if (auth.data != null) {
        setAuthenticated(true);
        return;
      }
      history.push(routePaths.login);
    }
  }, [authenticated, history, setAuthenticated]);
  return (
    <>
      <div className={styles.container}>
        <div className={styles.menu}>
          <SideMenu />
        </div>
        {downMdScreen && <HeaderMenu />}
        <Scrollbars
          renderTrackVertical={getTrackVertical}
          renderThumbVertical={getThumbVertical}
          className={styles.background}
        >
          <div className={styles.content} ref={contentRef}>{children}</div>
        </Scrollbars>
      </div>

      <SessionTimer />
      <ForcibleLogoutModal />
    </>
  );
};

export default MenuWrapper;
